import React from "react";

export default function NewTaskIcon({ className, size = 14, strokeWidth = 1.498, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="1.3 1.1 13.8 13.8"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M8.17 13.618H14.3M11.235 2.383a1.444 1.444 0 0 1 2.043 2.042l-8.512 8.512-2.723.68.68-2.723z" />
    </svg>
  );
}
